import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

const paymentsReducer = (state = initialState.payments, action: any) => {
  const stateClone = cloneDeep(state);

  switch (action.type) {
    case actionTypes.TOGGLE_PAYMENT_PROCESSING:
      set(stateClone, 'submitting', action.payload.inProgress);
      return stateClone;
    default:
      return state;
  }
};

export default paymentsReducer;
